import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { useDispatch, useSelector } from 'react-redux';
import qs from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import Paper from '../../Paper';
import Amount from '../../Amount';
import Button from '../../Button';
import Heading from '../../Heading/DesktopView';
import PizzaCard from '../partials/PizzaCard';
import IngredientCard from '../partials/IngredientCard';
import Tabs, { Tab } from '../partials/Tabs';
import Composition from '../partials/Composition';

// Style
import styles from './DesktopView.styl';
import { addReward } from '../../../state/modules/stock/actions';
import { includeIngredientsSelector } from '../../../state/modules/constructor/selectors';
import { getRoute, paths } from '../../../entry/routes';

const cx = classNames.bind(styles);

export default function DesktopView(props) {
  const {
    className,
    ingredients,
    variation,
    addToCart,
    totalPrice,
    addPortion,
    removePortion,
    removeIngredient,
    warning,
    activeStuffedCrust,
    isSauceSelected,
    isItSauce,
    selectedIngredients,
    isItSauceAfterTheOven,
  } = props;
  const [isAdding, setIsAdding] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const pizzaParams = qs.parse(location.search);
  const { isReward, rewardIndex } = pizzaParams;
  const dispatch = useDispatch();
  const includeIngredients = useSelector(state => includeIngredientsSelector(state, props));

  const addRewardToCart = async () => {
    const composition = [{ id: variation.id, ingredients: includeIngredients }];
    await dispatch(addReward(rewardIndex, composition, true));
  };

  const toNum = v => Number(v ?? 0) || 0;

  function onlyDeletedOrNotChanged(firstArray, secondArray) {
    const notChanged =
      firstArray.length === secondArray.length &&
      firstArray.every(
        (item, index) =>
          String(item.id) === String(secondArray[index].id) &&
          toNum(item.count) === toNum(secondArray[index].count),
      );

    if (notChanged) return true;

    const hasDeleted = firstArray.some(item => toNum(item.count) === 0);

    if (!hasDeleted) return false;

    const firstIds = new Set(firstArray.map(i => String(i.id)));

    const hasAdded = secondArray.some(item => !firstIds.has(String(item.id)));

    return !hasAdded;
  }

  const flag = onlyDeletedOrNotChanged(includeIngredients, selectedIngredients);
  const onBack = () => {
    return history.push(getRoute(paths.home));
  };
  const onAddToCart = async () => {
    setIsAdding(true);
    if (isReward && flag && rewardIndex !== null) {
      await addRewardToCart();
      onBack();
    } else {
      await addToCart();
    }
    setIsAdding(false);
  };
  return (
    <Paper className={cx('Constructor', className)}>
      <div className={cx('Constructor__info')} data-test-id="constructor_info">
        <PizzaCard {...variation} {...props} className={cx('Constructor__pizza-card')} />
        <div className={cx('Constructor__footer')}>
          <Button onClick={onAddToCart} isLoading={isAdding}>
            <FormattedMessage id="button.inCart" />
          </Button>
          <div className={cx('Constructor__price')}>
            <p className={cx('Constructor__price-label')}>
              <FormattedMessage id="label.total" />:
            </p>
            <Amount value={totalPrice} />
          </div>
        </div>
        <Composition
          {...variation}
          {...props}
          stuffed_crust={activeStuffedCrust}
          className={cx('Constructor__composition')}
        />
      </div>
      <div className={cx('Constructor__main')} data-test-id="constructor_main">
        <div className={cx('Constructor__header')}>
          <Heading className={cx('Constructor__title')} level={2} tagName="h1">
            {/* <FormattedMessage id="constructor.title" /> */}
          </Heading>
          <small className={cx('Constructor__note')}>
            <FormattedMessage id="constructor.note" />
          </small>
        </div>
        <Tabs>
          {Object.keys(ingredients).map(type => (
            <Tab key={type} disabled={!isSauceSelected} isItSauce={isItSauce} title={type}>
              <div
                className={cx('Constructor__ingredients')}
                data-test-id="constructor_ingredients"
              >
                {ingredients[type].map(ingredient => (
                  <IngredientCard
                    key={ingredient.id}
                    {...ingredient}
                    className={cx('Constructor__ingredient')}
                    addPortion={addPortion}
                    removePortion={removePortion}
                    onRemove={removeIngredient}
                    isItSauce={isItSauce}
                    isItSauceAfterTheOven={isItSauceAfterTheOven}
                    selectedIngredients={selectedIngredients}
                    isWarning={!!warning}
                  />
                ))}
              </div>
            </Tab>
          ))}
        </Tabs>
        {warning && (
          <div className={cx('Constructor__warning')}>
            <FormattedMessage id={warning} />
          </div>
        )}
      </div>
    </Paper>
  );
}

DesktopView.propTypes = {
  className: PropTypes.string,
  ingredients: PropTypes.object,
  variation: PropTypes.object.isRequired,
  addToCart: PropTypes.func.isRequired,
  totalPrice: PropTypes.number.isRequired,
  addPortion: PropTypes.func.isRequired,
  removePortion: PropTypes.func.isRequired,
  removeIngredient: PropTypes.func.isRequired,
  warning: PropTypes.bool.isRequired,
  activeStuffedCrust: PropTypes.string.isRequired,
  isSauceSelected: PropTypes.bool.isRequired,
  isItSauce: PropTypes.func.isRequired,
  selectedIngredients: PropTypes.object.isRequired,
};
